// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comparison {
  box-sizing: border-box;
  display: block;
  padding: 32px 16px 16px;
  margin: 1em 0;
  background: #f8f9fc;
  border: solid 1px #dde3f0;
  border-radius: 3px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 16px;
}

.comparison__correct:before,
.comparison__incorrect:before {
  content: 'Do';
  display: block;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  color: #505762;
  margin-bottom: 4px;
  position: absolute;
  bottom: 100%;
  left: 0;
}

.comparison__incorrect:before {
  content: "Don't";
}

.comparison__correct,
.comparison__incorrect {
  box-sizing: border-box;
  display: block;
  font-size: 14px;
  line-height: 20px;
  padding: 0px 7px;
  margin: 0;
  background: #fff;
  border-radius: 3px;
  font-family: sans-serif;
  position: relative;
}

.comparison__correct p,
.comparison__incorrect p {
  margin: 8px 0;
}

.ck .comparison__correct.ck-editor__nested-editable,
.ck .comparison__incorrect.ck-editor__nested-editable {
  border: solid 1px #dde3f0;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/comparison/styles.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,yBAAyB;AAC3B","sourcesContent":[".comparison {\n  box-sizing: border-box;\n  display: block;\n  padding: 32px 16px 16px;\n  margin: 1em 0;\n  background: #f8f9fc;\n  border: solid 1px #dde3f0;\n  border-radius: 3px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-column-gap: 16px;\n}\n\n.comparison__correct:before,\n.comparison__incorrect:before {\n  content: 'Do';\n  display: block;\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 500;\n  color: #505762;\n  margin-bottom: 4px;\n  position: absolute;\n  bottom: 100%;\n  left: 0;\n}\n\n.comparison__incorrect:before {\n  content: \"Don't\";\n}\n\n.comparison__correct,\n.comparison__incorrect {\n  box-sizing: border-box;\n  display: block;\n  font-size: 14px;\n  line-height: 20px;\n  padding: 0px 7px;\n  margin: 0;\n  background: #fff;\n  border-radius: 3px;\n  font-family: sans-serif;\n  position: relative;\n}\n\n.comparison__correct p,\n.comparison__incorrect p {\n  margin: 8px 0;\n}\n\n.ck .comparison__correct.ck-editor__nested-editable,\n.ck .comparison__incorrect.ck-editor__nested-editable {\n  border: solid 1px #dde3f0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
